import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_38338_31680)\"><rect x=\"0.850098\" y=\"0.850098\" width=\"14.3\" height=\"14.3\" rx=\"7.15\" fill=\"white\" stroke=\"#D4D4D8\" stroke-width=\"1.5\"></rect><path d=\"M2 2L14 14\" stroke=\"#DD9C9C\" stroke-width=\"1.5\" stroke-linecap=\"round\"></path></g><defs><clipPath id=\"clip0_38338_31680\"><rect width=\"16\" height=\"16\" rx=\"4\" fill=\"white\"></rect></clipPath></defs>", 2)
  ])))
}
export default { render: render }